if (!customElements.get('pdp-review-summary')) {
  customElements.define('pdp-review-summary', class PdpReviewSummary extends HTMLElement {
    connectedCallback() {
      this.locale = document.documentElement.lang || 'en';
      this.plurals = new Intl.PluralRules(this.locale);
      this.observer = new MutationObserver(() => this.updateLabel());
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-number-of-reviews'],
      });
      this.updateLabel();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    formatCount(count) {
      const template = this.dataset[this.plurals.select(count)] || this.dataset.other;
      return template?.replaceAll('[count]', count.toLocaleString(this.locale));
    }

    updateLabel() {
      const badge = this.querySelector('.jdgm-preview-badge .jdgm-prev-badge');
      if (!badge) return;
      const count = Number(badge.dataset.numberOfReviews);
      let link = badge.querySelector('.pdp-review-link');
      if (!Number.isSafeInteger(count) || count <= 0) {
        link?.remove();
        return;
      }
      const label = this.formatCount(count);
      if (!label) return;
      if (!link) {
        if (!document.getElementById('judgeme_product_reviews')) return;
        link = document.createElement('a');
        link.className = 'pdp-review-link';
        link.href = '#judgeme_product_reviews';
        badge.append(link);
      }
      if (link.textContent !== label) link.textContent = label;
    }
  });
}
